import type { ProductType } from "../config/products.config";

/**
 * Produit courant pour le système de support (widget, KB, prompts IA).
 *
 * Chaque app le déclare à l'init (main.tsx), comme pour initMonitoring :
 * la détection par pathname (useQuota.getCurrentProduct) ne fonctionne pas
 * pour les apps servies à la racine de leur propre domaine
 * (ex : form-polls sur www.dooquest.com).
 *
 * Défaut "date" : comportement historique préservé pour les apps qui ne
 * déclarent rien encore (date-polls, availability, quizz).
 */
let currentProduct: ProductType = "date";

export function setSupportProduct(product: ProductType): void {
  currentProduct = product;
}

export function getSupportProduct(): ProductType {
  return currentProduct;
}

/**
 * Retourne le nom de la marque (DooQuest pour form, DooDates pour autres).
 * Utilisé pour le branding aware du widget support et des emails.
 */
export function getBrandName(): string {
  return currentProduct === "form" ? "DooQuest" : "DooDates";
}
